import React = require("react")
import { IOWidget, Action, mkWidget } from "widgets-for-react"
import { BeslismatrixFormState, redirect_logic } from "./beslismatrixWizardState"
import { Form } from "../../../form"
import { submit_form_state } from "./beslismatrixWizardApi"
import { Entity } from "ts-lenses"
import { createMenus } from "../../../form/renderers"
import { loader } from "../../templates/loader.mod"


export let reset_timer_state = () => timer_state = "idle"
let timer_state: "busy" | "idle" = "idle"

export let beslismatrixWizardWidget: IOWidget<BeslismatrixFormState, Action<BeslismatrixFormState>> = (s0) =>
    mkWidget({
        run: (set_state) => {

            if (s0.RedirectLink != undefined && s0.RedirectLink != "" && timer_state == "idle") {
                timer_state = "busy"
                window.scrollTo(0, 0)
                setTimeout(() => window.location.assign(s0.RedirectLink), 10000)
            }

            if (s0.FormState == "not-ready") {
                return loader.run(_ => _)
            }
            return <>
                <ul className="block__tabs">
                    {createMenus(s0.FormState).run((s) =>
                        set_state(
                            (s1) =>
                                s1.FormState != "not-ready" && {
                                    ...s1,
                                    FormState: s(s1.FormState),
                                }
                        )
                    )}
                </ul>
                {(s0.RedirectLink == undefined || s0.RedirectLink == "") &&
                    Form(
                        (a) => set_state((s1) => {
                            let s2 = Entity(s1).set("FormState", () => {
                                if (s1.FormState != 'not-ready') {
                                    document.querySelector(".block__tabs").scrollIntoView();

                                    return a(s1.FormState)
                                }
                            }).commit()
                            if (s2.FormState.tabId && s2.FormState.tabId == -1) {
                                s2.FormState.formState.form_submission_logic = submit_form_state(s2.FormState)
                            }
                            let s3 = redirect_logic(s1, s2)

                            return s3
                        }),
                        s0.FormState,
                        s0,
                        set_state,
                        false,
                        s0.FormState.tabId,
                        s0.FormState.sectionId,
                    )(s0.FormState.formState).run((a) =>
                        set_state((s1) => {
                            let s2 = Entity(s1).set("FormState", formstate => {
                                if (formstate == "not-ready") return formstate

                                return Entity(formstate).set("formState", fs => {
                                    return a(fs)
                                }).commit()
                            }).commit()
                            let s3 = redirect_logic(s1, s2)

                            return s3
                        })
                    )
                }
            </>
        }
    })


